/* eslint-disable import/prefer-default-export */

import { getCookies } from '../api/api';
import { CryptoUtil } from './CryptoUtil';

export class CookieHelper {
  static setUserParams = (params: any) => {
    if (params && params.encodedTGT) {
      const cryptUserDataParams = CryptoUtil.encrypt(
        JSON.stringify({
          ...params,
        }),
      );
      getCookies().set('userDataParams', cryptUserDataParams);
    }
  };

  static setFB = (fb: boolean) => {
    getCookies().set('fb', fb.toString());
  };

  static isBloqueada = () => {
    let fb;
    if (
      getCookies().get('fb') !== null &&
      getCookies().get('fb') !== undefined
    ) {
      fb =
        getCookies().get('fb') !== undefined ? getCookies().get('fb') : 'false';
    }
    return fb === 'true';
  };

  static getUserParams = () => {
    const cryptedUserParams = getCookies().get('userDataParams');
    return cryptedUserParams
      ? JSON.parse(CryptoUtil.decrypt(cryptedUserParams))
      : null;
  };

  static setUserData = (objUser: any) => {
    getCookies().remove('userData');
    const cryptUserData = CryptoUtil.encrypt(
      JSON.stringify({
        ...objUser,
      }),
    );
    getCookies().set('userData', cryptUserData);
  };

  static getUserData = () => {
    const cryptedUser = getCookies().get('userData');
    return cryptedUser ? JSON.parse(CryptoUtil.decrypt(cryptedUser)) : null;
  };

  static removeUserCookies = () => {
    getCookies().remove('userData');
  };

  static removeUserCookiesForLogout = () => {
    getCookies().remove('userData');
    getCookies().remove('userDataParams');
    getCookies().remove('token');
    getCookies().remove('i18n');
    getCookies().remove('i18next');
  };

  static renewTokenData = (token: string) => {
    const userData = CookieHelper.getUserData();
    if (userData) {
      userData.user.token = token;
      CookieHelper.setUserData(userData);
    }
  };

  static renewToken(token: string, isRecuerdame?: boolean) {
    const options = CookieHelper.getExpiresOption(isRecuerdame);
    const userParams = CookieHelper.getUserParams();
    const userData = CookieHelper.getUserData();
    // const userDataV = CookieHelper.getUserDataV();
    CookieHelper.renewTokenData(token);

    getCookies().remove('userData');
    getCookies().remove('token');
    getCookies().remove('userDataParams');

    getCookies().set('token', token, options);
    getCookies().set(
      'userDataParams',
      CryptoUtil.encrypt(JSON.stringify(userParams)),
      options,
    );
    getCookies().set(
      'userData',
      CryptoUtil.encrypt(JSON.stringify(userData)),
      options,
    );
  }

  static setToken = async (token: string, isRecuerdame: boolean) => {
    const options = CookieHelper.getExpiresOption(isRecuerdame);
    getCookies().set('token', token, options);
  };

  private static getExpiresOption = (isRecuerdame: boolean | undefined) => {
    const now = new Date();
    if (isRecuerdame) {
      now.setTime(now.getTime() + 365 * 24 * 60 * 60 * 1000);
    } else {
      now.setTime(now.getTime() + 130 * 60 * 1000);
    }
    return {
      expires: now,
    };
  };
}
